"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortLayers = void 0;
exports.default = swapHalfSpreads;
const typeguards_1 = require("au-types/lib/typeguards");
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
const layers_1 = require("../layers");
const constants_1 = require("../../utils/constants");
const shiftDesignLayersRight_1 = require("../layers/shiftDesignLayersRight");
const findPrintableInProject_1 = __importDefault(require("./findPrintableInProject"));
const getSourceAndTargetData = (sourcePrintable, targetPrintable) => ({
  sourceDesignIds: {
    left: sourcePrintable.designId.split('|')[0],
    right: sourcePrintable.designId.split('|')[1]
  },
  targetDesignIds: {
    left: targetPrintable.designId.split('|')[0],
    right: targetPrintable.designId.split('|')[1]
  },
  sourceRightLayers: sourcePrintable.layers.filter(l => l.id.match(constants_1.SHIFTED_RIGHT_REGEX)),
  sourceLeftLayers: sourcePrintable.layers.filter(l => !l.id.match(constants_1.SHIFTED_RIGHT_REGEX)),
  targetRightLayers: targetPrintable.layers.filter(l => l.id.match(constants_1.SHIFTED_RIGHT_REGEX)),
  targetLeftLayers: targetPrintable.layers.filter(l => !l.id.match(constants_1.SHIFTED_RIGHT_REGEX))
});
const singlePrintableSideTradeLayers = _ref => {
  let {
    sourceRightLayers,
    sourceLeftLayers,
    sku,
    surface
  } = _ref;
  const shiftedRightLayers = (0, shiftDesignLayersRight_1.shiftDesignLayers)(layers_1.SpreadSide.RIGHT, sku, sourceLeftLayers, surface);
  const shiftedLeftLayers = (0, shiftDesignLayersRight_1.shiftDesignLayers)(layers_1.SpreadSide.LEFT, sku, sourceRightLayers, surface);
  return (0, exports.sortLayers)([...shiftedLeftLayers, ...shiftedRightLayers]);
};
const swapHalvesOnOnePrintable = _ref2 => {
  let {
    project,
    sourcePrintable,
    sourcePrintableIdx,
    targetPrintable,
    timestamp,
    interiorPrintablesGroup
  } = _ref2;
  const {
    sourceDesignIds,
    sourceRightLayers,
    sourceLeftLayers
  } = getSourceAndTargetData(sourcePrintable, targetPrintable);
  const newPrintableLayers = singlePrintableSideTradeLayers({
    sourceRightLayers,
    sourceLeftLayers,
    sku: project.product.sku,
    surface: sourcePrintable.surface
  });
  const newPrintable = (0, Printable_1.updatePrintableVersion)(Object.assign(Object.assign({}, sourcePrintable), {
    designId: `${sourceDesignIds.right}|${sourceDesignIds.left}`,
    layers: (0, exports.sortLayers)(newPrintableLayers)
  }), timestamp);
  interiorPrintablesGroup.printables[sourcePrintableIdx] = newPrintable;
  const updatedEntities = [newPrintable, project];
  return {
    updatedProject: project,
    updatedEntities: updatedEntities
  };
};
const getNewSourcePrintableAndTargetDesignId = _ref3 => {
  let {
    targetPrintable,
    sourcePrintable,
    sourceSide,
    targetSide,
    timestamp,
    sku
  } = _ref3;
  const {
    sourceDesignIds,
    targetDesignIds,
    sourceRightLayers,
    sourceLeftLayers,
    targetRightLayers,
    targetLeftLayers
  } = getSourceAndTargetData(sourcePrintable, targetPrintable);
  const sourceSideIsRight = sourceSide === layers_1.SpreadSide.RIGHT;
  let newTargetDesignId, newSourceDesignId, newSourcePrintable;
  if (!(targetPrintable === null || targetPrintable === void 0 ? void 0 : targetPrintable.isCompositeDesign)) {
    // Easy: the new source becomes the target (spread design)
    newSourcePrintable = (0, Printable_1.updatePrintableVersion)(Object.assign(Object.assign({}, targetPrintable), {
      id: sourcePrintable.id
    }), timestamp);
    // New target designId will be a "double" as it's replacing a spread
    newTargetDesignId = sourceSideIsRight ? `${sourceDesignIds.right}|${sourceDesignIds.right}` : `${sourceDesignIds.left}|${sourceDesignIds.left}`;
  } else {
    // We need to take all 4 designs into account
    const newSourceDesignIdLeft = sourceSideIsRight ? sourceDesignIds.left : targetDesignIds[targetSide];
    const newSourceDesignIdRight = sourceSideIsRight ? targetDesignIds[targetSide] : sourceDesignIds.right;
    newSourceDesignId = `${newSourceDesignIdLeft}|${newSourceDesignIdRight}`;
    const newTargetDesignIdLeft = targetSide === layers_1.SpreadSide.RIGHT ? targetDesignIds.left : sourceDesignIds[sourceSide];
    const newTargetDesignIdRight = targetSide === layers_1.SpreadSide.RIGHT ? sourceDesignIds[sourceSide] : targetDesignIds.right;
    newTargetDesignId = `${newTargetDesignIdLeft}|${newTargetDesignIdRight}`;
    let newSourceLayers;
    if (sourceSide === targetSide) {
      // source left target left => newSource = targetLeft + existing sourceRight
      // source right target right => newSource = existing sourceLeft + targetRight
      const newSourceRightLayers = sourceSideIsRight ? targetRightLayers : sourceRightLayers;
      const newSourceLeftLayers = sourceSideIsRight ? sourceLeftLayers : targetLeftLayers;
      newSourceLayers = (0, exports.sortLayers)([...newSourceLeftLayers, ...newSourceRightLayers]);
    } else {
      // source right target left => newSource = existing sourceLeft + targetLeft shifted right
      // source left target right => newSource = targetRight shifted left + existing sourceRight
      const newSourceLeftLayers = sourceSideIsRight ? sourceLeftLayers : (0, shiftDesignLayersRight_1.shiftDesignLayers)(layers_1.SpreadSide.LEFT, sku, targetRightLayers, targetPrintable.surface);
      const newSourceRightLayers = sourceSideIsRight ? (0, shiftDesignLayersRight_1.shiftDesignLayers)(layers_1.SpreadSide.RIGHT, sku, targetLeftLayers, targetPrintable.surface) : sourceRightLayers;
      newSourceLayers = (0, exports.sortLayers)([...newSourceLeftLayers, ...newSourceRightLayers]);
    }
    newSourcePrintable = (0, Printable_1.updatePrintableVersion)(Object.assign(Object.assign({}, sourcePrintable), {
      layers: newSourceLayers,
      designId: newSourceDesignId
    }), timestamp);
  }
  return {
    newSourcePrintable,
    newTargetDesignId
  };
};
const buildNewTargetPrintable = _ref4 => {
  let {
    sourcePrintable,
    targetPrintable,
    newTargetDesignId,
    sourceSide,
    targetSide,
    timestamp,
    sku
  } = _ref4;
  const sourceSideIsRight = sourceSide === layers_1.SpreadSide.RIGHT;
  const {
    sourceRightLayers,
    sourceLeftLayers,
    targetRightLayers,
    targetLeftLayers
  } = getSourceAndTargetData(sourcePrintable, targetPrintable);
  let newTargetLayers;
  let shiftedLayers;
  if (targetSide === sourceSide) {
    // source === target => target becomes source, shift dup opposite way
    newTargetLayers = sourceSideIsRight ? sourceRightLayers : sourceLeftLayers;
    const existingTargetLayers = targetSide === layers_1.SpreadSide.RIGHT ? targetLeftLayers : targetRightLayers;
    const shiftDirection = sourceSideIsRight ? layers_1.SpreadSide.LEFT : layers_1.SpreadSide.RIGHT;
    shiftedLayers = (targetPrintable === null || targetPrintable === void 0 ? void 0 : targetPrintable.isCompositeDesign) ?
    // keep existing other half
    existingTargetLayers :
    // duplicate source and shift to fill other half
    (0, shiftDesignLayersRight_1.shiftDesignLayers)(shiftDirection, sku, newTargetLayers, targetPrintable.surface).map(layer => Object.assign(Object.assign({}, layer), {
      userData: undefined
    }));
  } else {
    // source != target => shift target to sourceSide, source is cleaned original target
    shiftedLayers = (0, shiftDesignLayersRight_1.shiftDesignLayers)(
    // These are the ones being dragged onto target
    targetSide, sku, sourceSideIsRight ? sourceRightLayers : sourceLeftLayers, targetPrintable.surface);
    // Handle the other side
    if (targetPrintable === null || targetPrintable === void 0 ? void 0 : targetPrintable.isCompositeDesign) {
      // Keep existing other half of target in place
      newTargetLayers = targetSide === layers_1.SpreadSide.RIGHT ? targetLeftLayers : targetRightLayers;
    } else {
      // Duplicate (unshifted - same as original source half)
      newTargetLayers = (sourceSideIsRight ? sourceRightLayers : sourceLeftLayers).map(layer => Object.assign(Object.assign({}, layer), {
        userData: undefined
      }));
    }
  }
  return (0, Printable_1.updatePrintableVersion)(Object.assign(Object.assign({}, targetPrintable), {
    isCompositeDesign: true,
    designId: newTargetDesignId,
    layers: (0, exports.sortLayers)([...newTargetLayers, ...shiftedLayers])
  }), timestamp);
};
function swapHalfSpreads(project, action) {
  const {
    printableId: sourcePrintableId,
    sourceSide,
    targetPrintableId,
    targetSide
  } = action;
  const interiorPrintablesGroup = project.printableGroups.find(pg => pg.type === 'interior');
  const sourcePrintableIdx = interiorPrintablesGroup === null || interiorPrintablesGroup === void 0 ? void 0 : interiorPrintablesGroup.printables.findIndex(p => p.id === sourcePrintableId);
  const targetPrintableIdx = interiorPrintablesGroup === null || interiorPrintablesGroup === void 0 ? void 0 : interiorPrintablesGroup.printables.findIndex(p => p.id === targetPrintableId);
  const sourcePrintable = (0, findPrintableInProject_1.default)(project, sourcePrintableId);
  const targetPrintable = (0, findPrintableInProject_1.default)(project, targetPrintableId);
  if (!sourcePrintable || !targetPrintable || !(0, typeguards_1.isNumber)(sourcePrintableIdx) || !(0, typeguards_1.isNumber)(targetPrintableIdx) || !interiorPrintablesGroup) {
    return (0, either_1.left)(new Error(`printable not found: sourcePrintable: ${sourcePrintableId}, targetPrintable: ${targetPrintableId}`));
  }
  if (sourcePrintableId === targetPrintableId) {
    const swapHalvessOnOnePrintableResult = swapHalvesOnOnePrintable({
      project,
      sourcePrintable,
      targetPrintable,
      sourcePrintableIdx,
      timestamp: action.timestamp,
      interiorPrintablesGroup
    });
    return (0, either_1.right)(swapHalvessOnOnePrintableResult);
  }
  const {
    newSourcePrintable,
    newTargetDesignId
  } = getNewSourcePrintableAndTargetDesignId({
    sourcePrintable,
    targetPrintable,
    sourceSide,
    targetSide,
    timestamp: action.timestamp,
    sku: project.product.sku
  });
  const newTargetPrintable = buildNewTargetPrintable({
    newTargetDesignId,
    sourcePrintable,
    targetPrintable,
    sourceSide,
    targetSide,
    timestamp: action.timestamp,
    sku: project.product.sku
  });
  // Place the new printables in the correct spots
  project.printableGroups[1].printables[targetPrintableIdx] = newTargetPrintable;
  project.printableGroups[1].printables[sourcePrintableIdx] = newSourcePrintable;
  const updatedEntities = [newSourcePrintable, newTargetPrintable];
  updatedEntities.push(project);
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: updatedEntities
  });
}
const sortLayers = layers => {
  const sortedLayers = layers.slice(0).sort((a, b) => a.id > b.id ? 1 : -1);
  const rightText = sortedLayers.filter(layer => layer.id.includes('editable_text') && layer.id.match(constants_1.SHIFTED_RIGHT_REGEX));
  const leftText = sortedLayers.filter(layer => layer.id.includes('editable_text') && !layer.id.match(constants_1.SHIFTED_RIGHT_REGEX));
  const leftPhoto = sortedLayers.filter(layer => !layer.id.includes('editable_text') && !layer.id.match(constants_1.SHIFTED_RIGHT_REGEX));
  const rightPhoto = sortedLayers.filter(layer => !layer.id.includes('editable_text') && layer.id.match(constants_1.SHIFTED_RIGHT_REGEX));
  return [...leftPhoto, ...rightPhoto, ...leftText, ...rightText];
};
exports.sortLayers = sortLayers;